"use client"
import "leaflet/dist/leaflet.css"
import L from 'leaflet';
import React from "react";
import { MapContainer, TileLayer, Marker } from 'react-leaflet';

const center = {
  lat: 45.24096517319829,
  lng: 19.822115299320618
};

const ContactPageMap = () => {
  
  return (
    <MapContainer center={center} zoom={16} style={{width: '100%', height: '100%'}}>
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      />
      <Marker position={center} icon={L.divIcon({
        className: 'custom-marker',
        html: `<div><img src="/icon.png" style="width: 40px; height: auto"></div>`,
        iconSize: [30, 30],
        iconAnchor: [15, 15],
      })}>
      </Marker>
    </MapContainer>
  );

}

export default ContactPageMap;
